<template>
  <v-card>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 class="headline">Delete Approved Bill Line ({{ id }})?</v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="close()" :color="primaryGrey">Close</v-btn>
      <v-btn
        flat
        @click="deleteApprovedBillLine()"
        color="red darken-1"
        :loading="loading"
      >Delete Approved Bill Line</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ApprovedBillLineService from '@/services/requests/approvedBillLineService'
export default {
  props: {
    id: Number
  },
  data() {
    return {
      loading: false,
      deleteDocket: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async deleteApprovedBillLine() {
      try {
        this.loading = true
        const result = await ApprovedBillLineService.deleteApprovedBillLine(
          this.id
        )
        if (result) {
          this.$store.commit('approvedBillLines/deleteFromArrayStateById', {
            prop: 'approvedBillLines',
            id: this.id
          })
          this.loading = false
          this.close()
        }
      } catch (err) {
        console.log(err)
        this.snack({ text: err.response.data.message, color: 'red' })
        this.loading = false
        // this.close()
      }
    }
  }
}
</script>

<style>
</style>
